module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/098-guatemala-21c3224a540572ab2abebde1684868fb.svg";